import Vue from 'vue';
import Vuex from 'vuex';

import pageOffset from './modules/pageOffset.js';
import corp from './modules/corp.js';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        pageOffset,
        corp,
    }
})




// WEBPACK FOOTER //
// ./src/store/index.js